
import {queryIsHasNewArea,storeList,getBase,readAgree,confirmAgree} from '../../api/common'
import {getOneSettledList} from '../../api/entry'
import {getIndex} from '../../../TASMini/api/person'
const state = {
    isNewArea:false,//是否新增了业务范围
    message:'',
    type:1,
    lanuch:true,//是否存在业务区域未设置，true不存在,false存在
    storeList:[],
    isManage:false,//是否已经是某一个供应商的管理员了，如果是 不能新增供应商
    userInfo:{},
    showReadAgree:false,//登录弹框展示协议
    defaultPage:[],
  }
  const actions = {
    storeList(context){
      storeList({systemType:1}).then(res=>{
        console.log(res,'---当前登陆账号啊哈哈哈哈');
        if(res.code==200){
          context.commit('setStoreList',res.data?res.data:[])
          if(res.data&&res.data.length>0){
            let index =  res.data.findIndex(i=>i.admin==true)
            context.commit('setIsManage',index==-1?false:true)
          }
        }else{
          this.$message.error('供应商列表获取失败')
        }
      })
    },
    getUserInfo(context){
      getBase().then(res=>{
        if(res.code==200){
          
          context.commit('setUserInfo',res.data)
        }else{
          this.$message.error('用户信息获取失败')
        }
      })
    },
    queryIsHasNewArea(context){
      queryIsHasNewArea().then(res=>{
        console.log(res);
        if(res.code==200){
          context.commit('setIsNewArea',res.data.result);
          context.commit('setmessage',res.data.message)
          context.commit('settype',res.data.type)
        }else{
        // this.$message.error(res.message)
        }
      })
    },

    setLanuchFun(context){
      getOneSettledList().then(res=>{
        if(res.code==200){
          if(res.data.auditStatus==40){
            context.commit('setLanuch',res.data.launch)
          }else{
            context.commit('setLanuch',true)
          }
          
        }
      })
    },
    readAgree(context){
      readAgree({systemType:1}).then(res=>{
        context.commit('setShowReadAgree',res.data==0?true:false)
      })
    },
    confirmAgree(context){
      confirmAgree({systemType:1}).then(res=>{
        context.commit('setShowReadAgree',false)
      })
    },
    getIndex(context){
      if (this.$route.query && this.$route.query.isEntry) {
        return
      }
      getIndex(1).then(res=>{
        console.log(res,'------');
        if(res.data){
          context.commit('setDefaultPage',res.data)
        }
      })
    }


    


  }
  
  const mutations = { //改变状态
    setIsManage(state,evnt){
      state.isManage =evnt 
    },
    
    setStoreList:function(state,evnt){
        state.storeList  = evnt
    },
    setUserInfo(state,e){
      state.userInfo  = e
    },
    setDefaultUrl(state,e){
        state.indexUrl  = e
    },
    setIsNewArea(state,e){
        state.isNewArea  = e
    },
    setmessage(state,e){
        state.message  = e
    },
    settype(state,e){
        state.type  = e
    },
    setLanuch(state,e){
      state.lanuch = e
    },
    setShowReadAgree(state,e){
      state.showReadAgree = e
    },
    setDefaultPage(state,e){
      state.defaultPage = e
    }
  }
 
  export default {
    state,
    // getters,
    actions,
    mutations
  }
  


// WEBPACK FOOTER //
// ./src/SRM/store/modules/setting.js